export default __webpack_public_path__ + "static/media/game-end.5ed1c143.svg";